import { Flex, Group, Stack, Switch, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { EucdmCode, MultiLangCodes, TextInput } from '@components';
import { useCodeListSystem } from '@hooks/useCodeListSystem';
import { DeclarationViewDV1FormValues } from './DeclarationViewDV1';

interface SellerFormProps {
  form: UseFormReturnType<DeclarationViewDV1FormValues>;
  editDisabled: boolean;
  declarationGroup?: string;
  isExport?: boolean;
}

export const SellerForm: React.FC<SellerFormProps> = ({ form, editDisabled, declarationGroup, isExport }) => {
  const codelistSystems = useCodeListSystem({
    group: declarationGroup,
    isExport,
  });
  return (
    <Stack mb="xl">
      <Flex justify="space-between" align="center">
        <Title order={5} fw={600}>
          Seller
        </Title>
        <Switch {...form.getInputProps('dv1.seller.header')} checked={form.values.dv1.seller.header} label="Header" disabled={editDisabled} size="lg" />
      </Flex>

      <Group grow>
        <EucdmCode path="seller.name">
          <TextInput {...form.getInputProps('dv1.seller.name')} label="Name" disabled={editDisabled} />
        </EucdmCode>
        <EucdmCode path="seller.identificationNumber">
          <TextInput {...form.getInputProps('dv1.seller.identificationNumber')} label="Identification Number" disabled={editDisabled} />
        </EucdmCode>
      </Group>

      <Group grow>
        <EucdmCode path="seller.address.street">
          <TextInput {...form.getInputProps('dv1.seller.address.street')} label="Street" disabled={editDisabled} />
        </EucdmCode>
        <EucdmCode path="seller.address.postcode">
          <TextInput {...form.getInputProps('dv1.seller.address.postcode')} label="Postcode" disabled={editDisabled} />
        </EucdmCode>
        <EucdmCode path="seller.address.city">
          <TextInput {...form.getInputProps('dv1.seller.address.city')} label="City" disabled={editDisabled} />
        </EucdmCode>
        <EucdmCode path="seller.address.country">
          <MultiLangCodes {...form.getInputProps('dv1.seller.address.country')} label="Country" code="CL199" disabled={editDisabled} system={codelistSystems} />
        </EucdmCode>
      </Group>
    </Stack>
  );
};
